import type { ReactNode } from "react";

interface FieldWorkspaceProps {
  left: ReactNode;
  right: ReactNode;
}

/**
 * FieldWorkspace
 * Web-first split workspace for queue/review/action flows.
 * Collapses to single-column on narrow viewports.
 */
export function FieldWorkspace({ left, right }: FieldWorkspaceProps) {
  return (
    <section className="pg-workspace">
      <aside className="pg-workspace-left">{left}</aside>
      <div className="pg-workspace-right">{right}</div>
    </section>
  );
}

